// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyBXIy3uI6rIFjib6MdQ7d3Q9dIG4Wtm0eM",
  authDomain: "fir-react-app-3dfa4.firebaseapp.com",
  projectId: "fir-react-app-3dfa4",
  storageBucket: "fir-react-app-3dfa4.appspot.com",
  messagingSenderId: "437558788757",
  appId: "1:437558788757:web:6cd66af549a4e99e98919c",
  measurementId: "G-XW5C8WF9SD",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
